import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { FormField } from './form-field';
import { FormControlService } from './formfcontrol.service';
import { MessagerComponent } from '../messager/messager/messager.component';
import { RaterFormService } from '../raterform/raterform.service';
import { RaterformComponent } from '../raterform/raterform/raterform.component';


@Component({
  selector: 'app-dynamic-form',
  templateUrl: './dynamicform.component.html'
})
export class DynamicFormComponent implements OnInit {

  @Input() formFields: FormField<string>[] = [];
  @Input() picFields: FormField<string>[] = [];
  @Input() canvas: HTMLCanvasElement;
  @Input() image: HTMLImageElement;
  @Input() job_id: number;
  @Input() componentInstance: RaterformComponent;
  form: FormGroup;
  payLoad = '';


  constructor(private fcs: FormControlService, private messager: MessagerComponent, private rfService: RaterFormService) { }

  ngOnInit(): void {
    this.form = this.fcs.toFormGroup(this.formFields, this.picFields);
    this.fcs.setForm(this.form);
    console.log(this.form);
  }



  onSubmit() {
    this.payLoad = JSON.stringify(this.form.getRawValue());
    this.componentInstance.saveMF(this.payLoad)
  }

}
